import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { OrganisationService } from 'src/app/organisation.service';
import { MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
  selector: 'app-organisations',
  templateUrl: './organisations.component.html',
  styleUrls: ['./organisations.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class OrganisationsComponent implements OnInit {
  hasApiError = false;
  apiError: string;
  organisations: Array<any>;
  displayedColumns: string[] = ['name', 'cpu_seconds_remaining', 'actions'];

  constructor(
    public auth: AuthService,
    private api: ApiService,
    private orgService: OrganisationService
  ) { }

  ngOnInit() {

    this.hasApiError = false;

    this.api.getOrganisations$().subscribe({
      next: (orgs) => {
        this.organisations = orgs;
      },
      error: (err) => {
        this.hasApiError = true;
        this.apiError = err.message;
      }
    });
  }

  selectOrg(org: any) {
    this.orgService.setOrg(org);
  }
}
